import { darken } from 'polished';
import React, { FC, ReactNode, useMemo } from 'react';
import { Colors } from '../../../ui';
import { Pose } from '../../canvas/visualization/Pose';
import { RenderBounds, RenderBox, RenderInner, usePose } from '../../canvas/visualization/RenderHelpers';
import { RenderText } from '../../canvas/visualization/RenderText';
import { Textbox } from './Textbox';
import { TextboxLayout } from './TextboxLayout';

const useBorderFromPose = (pose: Pose, background: string) => {
    return useMemo(() => {
        const { selected, targeted, pressed, beingEdited } = pose;
        if (beingEdited) return `solid 2px ${Colors.primary}`;
        if (!selected && pressed) return `solid 2px ${Colors.primaryDark}`;
        if (!selected && targeted) return `solid 2px ${Colors.primary}`;
        if (!background) return 'solid 2px transparent';
        return `solid 2px ${darken(.15, background)}`;
    }, [pose, background]);
};

const RenderDesign = React.memo<{ layout: TextboxLayout, border: string }>(({ layout, border }) => {
    // const { selected, targeted, pressed, beingEdited } = usePose(object);
    // const interaction = usePressable(object, 'default');

    // const getBorder = () => {
    //     const bg = object.background;
    //     if (beingEdited) return `solid 2px ${Colors.primary}`;
    //     if (!selected && pressed) return `solid 2px ${Colors.primaryDark}`;
    //     if (!selected && targeted) return `solid 2px ${Colors.primary}`;
    //     if (!bg) return 'solid 2px transparent';
    //     return `solid 2px ${darken(.15, bg)}`;
    // };

    const style = {
        ...layout.base.toCSS(),
        backgroundColor: layout.background || 'transparent',
        border,
        borderRadius: '4px',
    };

    return <RenderBox {...style} />;
});

export const TextboxVisual: FC<{ object: Textbox, children?: ReactNode }> = ({ object }) => {
    const { layout, value } = object;
    const { beingEdited } = usePose(object);
    const border = useBorderFromPose(Pose.get(object), object.background);
    return <>
        <RenderBounds object={object}>
            <RenderInner object={object}>
                <RenderDesign layout={layout} border={border} />
                {!beingEdited && <RenderText {...layout.value} value={value} />}
            </RenderInner>
        </RenderBounds>
    </>;
};
